import { r } from './Table.style';
const RowTable = ({ data, titleWidth }: any) => {
  return (
    <r.RowContainer>
      <r.TableRowDirection>
        {data.map((item: any, index: number) => (
          <r.RowTableBox key={index}>
            <r.RowTableTitle witdh={titleWidth}>{item.key}</r.RowTableTitle>
            <r.RowTableContent>{item.value}</r.RowTableContent>
          </r.RowTableBox>
        ))}
      </r.TableRowDirection>
    </r.RowContainer>
  );
};

export { RowTable };
